import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';

export default class extends Controller {
  static get targets() {
    return ['product', 'quantity', 'price', 'total', 'grossweight', 'netweight'];
  }

  integerChange(event) {
    if (
      (event.key.length > 1) || 
      (
        (event.key === "-") &&
        (event.currentTarget.value.length === 0)
      ) ||
      /\d/.test(event.key)
    ) return;
    event.preventDefault();
  }
  
  connect(){
    var productData = $(this.productTarget).data('product');
    if (!productData.measure_unit.is_decimal) {
      // Unit of measure allows only integer values
      $(this.quantityTarget).
        prop('step', 1).
        prop('pattern', '/d+').
        on('keydown', this.integerChange);      
    }
  }
  
  setCalculatedFields(event) {
    var productData = $(this.productTarget).data('product');
    var quantity = +this.quantityTarget.value;
    var price = this.hasPriceTarget ? +this.priceTarget.value : 0;
    if (quantity>0) {
      var productGrossweight = +productData.gross_weight;
      if (productGrossweight==0) productGrossweight = 1;
      var productNetweight = +productData.net_weight;
      if (productNetweight==0) productNetweight = 1;
      var grossweight = quantity*productGrossweight;
      var netweight = quantity*productNetweight;
      $(this.grossweightTarget).html(formatWeight(grossweight));
      $(this.element).find('.or-gross-weight').val(grossweight);
      $(this.netweightTarget).html(formatWeight(netweight));
      $(this.element).find('.or-net-weight').val(netweight);

      if (price>0) {
        var total = quantity*price;
    
        $(this.totalTarget).html(formatMoney(total));
        $(this.element).find('.or-total').val(total);
      }

      let odivUpdateEvent = new CustomEvent("odiv-update");
      window.dispatchEvent(odivUpdateEvent);
    }
    console.log('setCalculatedFields', quantity, price, productData);
  }

  removeRow(event) {
    let odivUpdateEvent = new CustomEvent("odiv-update");
    window.dispatchEvent(odivUpdateEvent);
  }
}
